
import React, {useEffect, useRef, useState} from "react";
import CambioIdioma from "../scripts/CambioIdioma";
import Datos from "../../utilidades/Colecciones.json";
import SelectOrderAscDesc from "../componentesSecundarios/SelectOrderAscDesc";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
export default function SelectOrderUno(){
  const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
  const _filtros= useStoreGlobal(useShallow((state) => state._filtros));
    const [optionsFil, setOptionsFiltros] = useState([]);
    const selectFil = useRef(null);
    const ordenaren = useRef(null);
    const [selectedOrder, setSelectedOrder] = useState("");
    const [selectedFiltros, setSelectedFiltros] = useState("");
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en";
    }
    const handleSelectChangeFiltro = (event) => {
        const camposOrdenar = event.target.value;
        setSelectedFiltros(camposOrdenar);
        _updateFiltros({camposOrden:camposOrdenar});
        _updateFiltros({paginaFin:10});
        $("#search").trigger("click");
    }
    let coleccion = "";
    if(Object.keys(_filtros).length >= 1){
      coleccion = _filtros.coleccion;
    }
    const seleccionSelectAsc = (seleccion) =>{
      setSelectedOrder(seleccion);
    };
    useEffect(() => {
        if (ordenaren !== null) {
          CambioIdioma.valida(var_ingles, ordenaren);
        }
        let x=[];
        if (coleccion =="Areageograficas"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].areasOrdenar.español);
            x=Datos[0].areas.español;
          } else {
            setOptionsFiltros(Datos[0].areasOrdenar.ingles);
            x=Datos[0].areas.español;
          }
        }
        if (coleccion =="Datos_abiertos"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].datosAbiertosOrdenar.español);
            x=Datos[0].datosAbiertosOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].datosAbiertosOrdenar.ingles);
            x=Datos[0].datosAbiertosOrdenar.español;
          }
        }
        if (coleccion =="DENUE"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].denueOrdenar.español);
            x=Datos[0].denueOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].denueOrdenar.ingles);
            x=Datos[0].denueOrdenar.español;
          }
        }
        if (coleccion =="Glosario"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].glosarioOrdenar.español);
            x=Datos[0].glosarioOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].glosarioOrdenar.ingles);
            x=Datos[0].glosarioOrdenar.español;
          }
        }
        if (coleccion =="Indicadores"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].indicadoresOrdenar.español);
            x=Datos[0].indicadoresOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].indicadoresOrdenar.ingles);
            x=Datos[0].indicadoresOrdenar.español;
          }
        }
        if (coleccion =="Infraestructura"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].infraestructuraOrdenar.español);
            x=Datos[0].infraestructuraOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].infraestructuraOrdenar.ingles);
            x=Datos[0].infraestructuraOrdenar.español;
          }
        }
        if (coleccion =="Investigación"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].investigacionOrdenar.español);
            x=Datos[0].investigacionOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].investigacionOrdenar.ingles);
            x=Datos[0].investigacionOrdenar.español;
          }
        }
        if (coleccion =="Herramientas"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].herramientasOrdenar.español);
            x=Datos[0].herramientasOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].herramientasOrdenar.ingles);
            x=Datos[0].herramientasOrdenar.español;
          }
        }
        if (coleccion =="Mapas"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].mapasOrdenar.español);
            x=Datos[0].mapasOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].mapasOrdenar.ingles);
            x=Datos[0].mapasOrdenar.español;
          }
        }
        if (coleccion =="Microdatos"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].microdatosOrdenar.español);
            x=Datos[0].microdatosOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].microdatosOrdenar.ingles);
            x=Datos[0].microdatosOrdenar.español;
          }
        }
        if (coleccion =="Noticias"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].noticiasOrdenar.español);
            x=Datos[0].noticiasOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].noticiasOrdenar.ingles);
            x=Datos[0].noticiasOrdenar.español;
          }
        }
        if (coleccion =="Programas"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].programasOrdenar.español);
            x=Datos[0].programasOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].programasOrdenar.ingles);
            x=Datos[0].programasOrdenar.español;
          }
        } 
        if (coleccion =="Publicaciones"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].publicacionesOrdenar.español);
            x=Datos[0].publicacionesOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].publicacionesOrdenar.ingles);
            x=Datos[0].publicacionesOrdenar.español;
          }
        }
        if (coleccion =="Tabulados"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].tabuladosOrdenar.español);
            x=Datos[0].tabuladosOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].tabuladosOrdenar.ingles);
            x=Datos[0].tabuladosOrdenar.español;
          }
        }
        if (coleccion =="Temas"){
          if (var_ingles === "es") {
            setOptionsFiltros(Datos[0].temasOrdenar.español);
            x=Datos[0].temasOrdenar.español;
          } else {
            setOptionsFiltros(Datos[0].temasOrdenar.ingles);
            x=Datos[0].temasOrdenar.español;
          }
        }
        if(coleccion !== "Todo"){
          const valor = x[0].value;
          _updateFiltros({camposOrden:valor});
        }
    }, [coleccion]);
    return(
      <div className="col-md-11 col-lg-4" id="idOrdenar">
        <div id="todo_ordenar">
          <div id="todoroworder">
            <div className="tamanoalineacioncombos" id="todoroworder">
              <div className="row">
                <div className="col-md-2" id="rowordenar" style={{ marginTop: "9px" }}>
                  <div id="ordenaren" ref={ordenaren}></div>
                </div>
                <div className="tamChec2 col-md-11 col-lg-6 col-11" id="comboTamanop">
                    <select
                      className="form-select"
                      ref={selectFil}
                      value={selectedFiltros}
                      onChange={handleSelectChangeFiltro}
                      name="Ordenar"
                      id="selectordenar"
                    >
                      {optionsFil.map((filtros,i) => (
                        <option key={"coleccionesOrdenarTodos-" + i} value={filtros.value}>
                          {filtros.name}
                        </option>
                      ))}
                    </select>
                </div>
                <SelectOrderAscDesc handleSelecAscDesc={seleccionSelectAsc}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};